import { render } from "./RolePrivilegesModal.vue?vue&type=template&id=5fd65a38"
import script from "./RolePrivilegesModal.vue?vue&type=script&lang=js"
export * from "./RolePrivilegesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__